/** POST companies/add-tradie — message when the user already exists; invite only until accept. */
export const ADD_TRADIE_INVITE_ONLY_MESSAGE =
  'An invitation has been sent to this tradie.'

/** POST companies/add-tradie — message when a new account was created and linked. */
export const ADD_TRADIE_NEW_ACCOUNT_MESSAGE =
  'Tradie has been added successfully!'

/** CSV import — API may return these (exact strings from backend). */
export const CSV_IMPORT_MSG_INVITES_ONLY =
  'Invitations were sent to existing accounts.'

export const CSV_IMPORT_MSG_WITH_SKIPS = 'Import completed with skipped rows.'
